<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <p>Utiliser le site https://www.uuidgenerator.net/ pour generer un uuid unique. (le système detectera si l'uuid est déja utilisé)</p>
          <v-text-field
            v-model="item.uuid"
            :error-messages="uuidErrors"
            :label="$t('global.uuid')"
            required
            @input="$v.item.uuid.$touch()"
            @blur="$v.item.uuid.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="materialProductSelectItems"
            v-model="item.materialProduct"
            :items="materialProductSelectItems"
            :error-messages="materialProductErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('profile.material.product')"
            item-text="name"
            item-value="@id"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <p>Format : x.x.x (1.0.0, 1.2.1, ...)</p>
          <v-text-field
            v-model="item.version"
            :error-messages="versionErrors"
            :label="$t('global.version')"
            required
            @input="$v.item.version.$touch()"
            @blur="$v.item.version.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('global.hub') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.public"
                :error-messages="publicErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.comment"
            :error-messages="commentErrors"
            :label="$t('global.comment')"
            required
            @input="$v.item.comment.$touch()"
            @blur="$v.item.comment.$touch()"
          />
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'MaterialProductVersionForm',
  mixins: [validationMixin],
  components: {
    Loading,
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.materialProductGetSelectItems();
  },
  data() {
    return {
        uuid: null,
        version: null,
        public: null,
        materialProduct: null,
        comment: null,
    };
  },
  computed: {
    isLoading() {
      return (
        this.isLoading_materialProduct
       );
    },
    ...mapFields('materialproduct', {
      materialProductSelectItems: 'selectItems',
      isLoading_materialProduct : 'isLoading'
    }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },
    uuidErrors() {
      const errors = [];
      if (!this.$v.item.uuid.$dirty) return errors;
      has(this.violations, 'uuid') && errors.push(this.violations.uuid);
      !this.$v.item.uuid.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    versionErrors() {
      const errors = [];
      if (!this.$v.item.version.$dirty) return errors;
      has(this.violations, 'version') && errors.push(this.violations.version);
      !this.$v.item.version.required && errors.push(this.$t('global.field_required'));
      return errors;
    },
    publicErrors() {
      const errors = [];
      if (!this.$v.item.public.$dirty) return errors;
      has(this.violations, 'public') && errors.push(this.violations.public);
      return errors;
    },
    commentErrors() {
      const errors = [];
      if (!this.$v.item.comment.$dirty) return errors;
      has(this.violations, 'comment') && errors.push(this.violations.comment);
      return errors;
    },
    materialProductErrors() {
      const errors = [];
      if (!this.$v.item.materialProduct.$dirty) return errors;
      has(this.violations, 'materialProduct') && errors.push(this.violations.materialProduct);
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
    ...mapActions({
      materialProductGetSelectItems: 'materialproduct/fetchSelectItems',
    }),
  },
  validations: {
    item: {
      uuid: {
        required,
      },
      version: {
        required,
      },
      public: {
      },
      comment: {
      },
      materialProduct: {
      },
    }
  }
};
</script>
